import { ApiClient } from '@/common/api/ApiClient';
import { emsStatusSchema, type EmsStatus } from '@/features/telemetry/services/schemas';

/**
 * TODO(backend): no EMS connectivity endpoint exists in EMS Backend.yaml yet.
 *
 * Proposed contract: `GET /api/v1/system/{system_id}/status`
 *   -> `{ last_message_at: string | null (ISO-8601, tz-aware), is_online: boolean }`
 * (camelized to `lastMessageAt`/`isOnline` by ApiClient's normal response interceptor,
 * same as every other endpoint — this one has no dynamic keys, so it needs no special
 * handling like `/telemetry` does.)
 *
 * Until that ships, this always resolves from the mock factory below — the EMS status
 * bar it feeds is fully built and works against the mock, but has no live data source.
 */
export const EmsStatusService = {
  getStatus: (systemId: number): Promise<EmsStatus> => {
    return ApiClient.get(`/system/${systemId}/status`, emsStatusSchema, undefined, {
      // mock: bypasses axios (and its humps interceptors) entirely, so this must
      // already be shaped the way the schema expects to parse it — camelCase.
      mock: () => ({
        lastMessageAt: new Date(Date.now() - 75_000),
        isOnline: true,
      }),
    });
  },
};
